module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Illustration",
      "id": "fig-002",
      "src": "images/BANNER_Practice_gray.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("Choose Joy")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This first exercise is adapted from the prayer of examen, a contemplative practice created by Ignatius of Loyola in the sixteenth century to examine our days, detect God’s presence, and discern God’s purposes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" He referred to those elements of our day that bring us closer to God as "), _c('i', [_vm._v("consolations")]), _vm._v(" and those that distance us from God as "), _c('i', [_vm._v("desolations")]), _vm._v(". I reshaped this concept to focus on our enjoyment of God and God’s joy in us. This is a great way to start our journey into the delight of God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Gather a blank sketch book or journal and some colored crayons, pens, or pencils. Write “I choose joy” on the first blank page in bold colored letters.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Each night for the next week prayerfully think back over your day.")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What did you enjoy doing? What made you smile, laugh, dance, or shout out loud for joy today?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("How did you respond to these joyful moments?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Use your colored pencil to decorate the words you wrote. If you feel inclined, embellish your reflections with sketches, photos, or words of praise. Perhaps you would like to dance around your room in response or “make a joyful noise” on a drum or guitar.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Imagine God entering into your joy.")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("In what ways did these joyful moments make you sense God’s pleasure and draw you closer to God?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("In what ways did they draw you closer to others?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What creative impulses or responses did they stir within you?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What could you do tomorrow to cultivate and grow that joy?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Name the tensions.")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What destroyed your joy today and made you feel distant from God?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("What distanced you from others and perhaps destroyed their joy?")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What adjustments could you make to overcome the tensions and restore your joy?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Reward yourself.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Each evening, reward yourself for the creative responses that enhanced your joy. Give yourself a special treat for each tension that turned into a joy-filled moment where you sensed God’s pleasure: eat a chocolate, listen to your favorite song, spend a few extra moments playing with your children. Laugh at yourself. Toast yourself for being a person who is able to overcome tension and create joy spots. As you laugh I hope that you will sense God’s approval of your contemplation.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the end of the week take extra time to relax and look back over your week.")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What gave you the greatest joy?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What do you think gave the greatest pleasure to God?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What could you do this coming week to expand your own joy and the pleasure you brought to God?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As a reward, plan a trip to a place you enjoy—an art gallery or museum; a garden you love; the beach or mountains; the oldest, most beautiful, or unusual building in your town; the local nursery or fabric store. Have some fun, enjoy life, and enjoy God.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Have fun with your friends")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If you are meeting as a group, get each person to share their joys and distractions from the week. Talk about their responses and where God seemed close or distant. Laugh together. Have some fun. Reward the person who related the most joy-filled moments with a prize or special treat. Give another reward for the one whose response made you laugh the most.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Reflect on your time together. Where did you as a group sense God’s pleasure? What new practices might come out of this experience?")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 72
// module chunks = 0